import "react-notifications/lib/notifications.css";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

export const success = (message, options) => {
  if (options) {
    toastr.options = options;
  } else {
    toastr.options = {
      positionClass: "toast-top-right",
      timeOut: 3000,
      closeButton: false,
    };
  }
  toastr.success(message);
};

export const info = (message, options) => {
  if (options) {
    toastr.options = options;
  } else {
    toastr.options = {
      positionClass: "toast-top-right",
      timeOut: 3000,
      closeButton: false,
    };
  }

  toastr.info(message);
};

export const warning = (message, options) => {
  if (options) {
    toastr.options = options;
  } else {
    toastr.options = {
      positionClass: "toast-top-right",
      timeOut: 3000,
      closeButton: false,
    };
  }

  toastr.warning(message);
};

export const error = (message, options) => {
  if (options) {
    toastr.options = options;
  } else {
    toastr.options = {
      positionClass: "toast-top-right",
      timeOut: 3000,
      closeButton: false,
    };
  }

  toastr.error(message);
};
